// extracted by mini-css-extract-plugin
export const detailsBox = "details-box-module--detailsBox--3If1F";
export const dark = "details-box-module--dark--2AiHK";